var _defs, _circle, _circle2, _circle3, _g, _g2, _g3, _line, _line2, _line3, _path, _path2, _path3, _circle4, _circle5, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechstrideValuesIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purpleGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6d28d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyanGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0ea5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0369a1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.15
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 400,
    r: 80,
    fill: "#dbeafe",
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 100,
    r: 70,
    fill: "#dbeafe",
    opacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 120,
    fill: "#dbeafe",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 60,
    fill: "white",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30, -30) scale(0.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "url(#blueGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15,-5 L15,-5 L15,15 L-15,15 Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8,2 L8,2 M-8,8 L8,8",
    fill: "none",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20,-20 L-10,-20 M-20,-14 L-5,-14 M-20,-8 L-8,-8",
    fill: "none",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,-20 L10,-20 M20,-14 L5,-14 M20,-8 L8,-8",
    fill: "none",
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -40,
    cy: -20,
    r: 8,
    fill: "#93c5fd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: -20,
    r: 8,
    fill: "#93c5fd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -50,
    r: 8,
    fill: "#93c5fd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 60,
    fill: "white",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30, -30) scale(0.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "url(#purpleGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-20 L20,10 L0,0 L-20,10 Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10,15 L10,15",
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -40,
    cy: -20,
    r: 8,
    fill: "#c4b5fd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: -20,
    r: 8,
    fill: "#c4b5fd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -50,
    r: 8,
    fill: "#c4b5fd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 60,
    fill: "white",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30, -30) scale(0.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "url(#cyanGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10,
    cy: -5,
    r: 10,
    fill: "none",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -5,
    r: 10,
    fill: "none",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20,15 C-10,25 10,25 20,15",
    fill: "none",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -40,
    cy: -20,
    r: 8,
    fill: "#7dd3fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: -20,
    r: 8,
    fill: "#7dd3fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -50,
    r: 8,
    fill: "#7dd3fc"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 180,
    x2: 230,
    y2: 270,
    stroke: "#bfdbfe",
    strokeWidth: 3,
    strokeDasharray: "5,5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 180,
    x2: 270,
    y2: 270,
    stroke: "#bfdbfe",
    strokeWidth: 3,
    strokeDasharray: "5,5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 140,
    x2: 320,
    y2: 140,
    stroke: "#bfdbfe",
    strokeWidth: 3,
    strokeDasharray: "5,5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470,250 L490,280 L450,280 Z",
    fill: "#93c5fd",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,220 L50,250 L10,250 Z",
    fill: "#93c5fd",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250,450 L270,480 L230,480 Z",
    fill: "#93c5fd",
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 15,
    fill: "#3b82f6",
    opacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 430,
    r: 15,
    fill: "#3b82f6",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 200,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#3b82f6",
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 300,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#3b82f6",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechstrideValuesIllustration);
export default __webpack_public_path__ + "static/media/techstride-values-illustration.2547f1407d4b7cff4698c48d46860835.svg";
export { ForwardRef as ReactComponent };